import React from 'react'
import PropTypes from 'prop-types'

// @ts-ignore
import SelectGenericValueEmpty from "./value/value-empty"
// @ts-ignore
import SelectGenericValueNotEmpty from "./value/value-not-empty"
// @ts-ignore
import SelectGenericPopoverMenu from "./popover/popover-menu"

const debug = false
// const debug = "SelectGenericNew"

export default class SelectGenericNew extends React.Component<any,any> {

    public previousOption   : any
    public currentOption   : any

    static propTypes = {
        options                         : PropTypes.array,
        value                           : PropTypes.any,

        valueClasses                    : PropTypes.string, // classes assigned to empty/not empty selector view components

        placeholder                     : PropTypes.string,
        noValueOptionLabel              : PropTypes.string,

        popoverClasses                  : PropTypes.string,
        popoverScrollContainerClasses   : PropTypes.string,

        noValueOption                   : PropTypes.bool,   // is all values option available
        noValueOptionNoAccent           : PropTypes.bool,   // show no value option as placeholder (ui5-txt-no-accent-default)
        isSearchable                    : PropTypes.bool,   // is used in popover
        disabled                        : PropTypes.bool,
        scrollToSelected                : PropTypes.bool,

        valueComponent                  : PropTypes.func,
        valueEmptyComponent             : PropTypes.func,
        iconComponent                   : PropTypes.func,   // is used in default SelectMultiGenericValueEmpty component
        popoverOptionComponent          : PropTypes.func,

        onChange                        : PropTypes.func,
    }

    static defaultProps = {
        placeholder             : 'Please select',
        noValueOption           : false,
        noValueOptionLabel      : 'None',
        scrollToSelected        : true
    }

    constructor(props:any) {
        super(props);

        this.state = {
            initialPropsValue   : props.value,
            currentOption       : _.find(props.options, option => option.value === props.value),
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        if (props.value !== state.initialPropsValue) {
            return {
                initialPropsValue   : props.value,
                currentOption       : _.find(props.options, option => option.value === props.value),
            }
        }
        return null
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        this.previousOption = this.state.currentOption

        let currentOption:any
        if (!!option.isNoValueOption) {
            currentOption = null
        } else {
            currentOption = option
        }

        this.setState({
            currentOption   : currentOption,
            showPopover     : false,
        }, () => {
            if (this.props.onChange) this.props.onChange(currentOption, this.onCancelChange)
        })
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.currentOption
        })
    }

    _getValueComponent = (selectedOption:any) => {
        let ValueComponent

        if (!!selectedOption) {
            ValueComponent = this.props.valueComponent || SelectGenericValueNotEmpty
        } else {
            ValueComponent = this.props.valueEmptyComponent || SelectGenericValueEmpty
        }

        return ValueComponent
    }

    render() {
        const classes: string = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'disabled'      : this.props.disabled
        })

        let ValueComponent = this._getValueComponent(this.state.currentOption)

        debug && console.log(debug, "render", this.props.placeholder, this.state.currentOptions, this.state.currentOption)

        return (
            <ValueComponent className               = {classes}
                            valueClasses            = {this.props.valueClasses}
                            placeholder             = {this.props.placeholder}
                            noValueOption           = {this.props.noValueOption}
                            noValueOptionNoAccent   = {this.props.noValueOptionNoAccent}
                            noValueOptionLabel      = {this.props.noValueOptionLabel}
                            iconComponent           = {this.props.iconComponent}
                            option                  = {this.state.currentOption}
                            onClick                 = {!this.props.disabled ? this.showPopover : null}
                            onDelete                = {!this.props.disabled ? this.onOptionClick : null}>
                {this.state.showPopover && <SelectGenericPopoverMenu {...this.props} parent={this}/>}
            </ValueComponent>
        )
    }
}